import { render, staticRenderFns } from "./__detail_item_list_store.vue?vue&type=template&id=6e2fc842&scoped=true&"
import script from "./__detail_item_list_store.vue?vue&type=script&lang=js&"
export * from "./__detail_item_list_store.vue?vue&type=script&lang=js&"
import style0 from "./__detail_item_list_store.vue?vue&type=style&index=0&id=6e2fc842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2fc842",
  null
  
)

export default component.exports